import { useEffect, useState } from 'react';
import { Button, Form, Row } from 'react-bootstrap';
import AutocompleteInput from '../../../shared/components/AutocompleteInput';
import { ErrorToast } from '../../../utils/toasters';
import { CompanyService } from '../../company/CompanyService';
import SingleSelectDropdown from '../../../shared/components/SingleSelectDropdown';
import { UserService } from '../../user/UserService';
import { CampaignsService } from '../../campaigns/CampaignsService';
import { Campaign } from '../../../model/campaign/Campaign';
import { Company } from '../../../model/company/Company';
import { IUser } from '../../../model/user/IUser';
import { IFiltersAgencyRevenueCampaigns } from './AgencyRevenueCampaigns';
interface IAgencyRevenueCampaignsFilter {
    handleState: (params: IFiltersAgencyRevenueCampaigns, pageOverride?: number) => void;
    setState: React.Dispatch<React.SetStateAction<IFiltersAgencyRevenueCampaigns>>;
    offersFilter: IFiltersAgencyRevenueCampaigns;
}
export function AgencyRevenueCampaignsFilter({ handleState, setState, offersFilter }: IAgencyRevenueCampaignsFilter) {
    const [clients, setClients] = useState<Company[]>([]);
    const [managers, setManagers] = useState<IUser[]>([]);
    const [clientFilter, setClientFilter] = useState('');
    const [managerFilter, setManagerFilter] = useState('');
    const [campaigns, setCampaigns] = useState<Campaign[]>([]);
    const [campaignFilter, setCampaignFilter] = useState('');
    useEffect(() => {
        CampaignsService.getCampaigns({ perPage: 15, title: campaignFilter })
            .then(data => {
                setCampaigns(data.data);
            })
            .catch(err => ErrorToast(err));
    }, [campaignFilter]);
    useEffect(() => {
        CompanyService.getCompanyPartnersAssigned({
            companyId: 5,
            type: 'supplier',
            perPage: 15,
            displayName: clientFilter,
        })
            .then(data => {
                setClients(data.data);
            })
            .catch(err => ErrorToast(err));
    }, [clientFilter]);

    useEffect(() => {
        UserService.getUsers({ brandCompanyId: 5, search: managerFilter, isEnabled: true })
            .then(data => {
                setManagers(data.data);
            })
            .catch(err => {
                ErrorToast(err);
            });
    }, [managerFilter]);

    function handleChanges(evt: React.ChangeEvent<HTMLSelectElement>) {
        const { name, value } = evt.target;
        let parsedValue: string | boolean | undefined = value;
        if (value === 'true') parsedValue = true;
        else if (value === 'null') parsedValue = false;
        else if (value === 'undefined') parsedValue = undefined;
        setState({
            ...offersFilter,
            [name]: parsedValue || currentYear,
            page: 1,
        });
    }

    const currentYear = new Date().getFullYear();
    const startYear = 2017;
    const endYear = 2040;

    const years = Array.from({ length: endYear - startYear + 1 }, (_, i) => startYear + i);

    return (
        <Form>
            <Row style={{ rowGap: '18px' }}>
                <div className="col-6 col-md-3 autocomplete-input">
                    <AutocompleteInput
                        placeholder="Campaign name"
                        onSelect={campaign => {
                            setState({
                                ...offersFilter,
                                campaignId: campaign.id,
                                page: 1,
                            });
                        }}
                        setFilter={setCampaignFilter}
                        value={campaignFilter}
                        items={campaigns}
                        hasClearBtn
                        renderItems={['id', 'title']}
                        clearFunc={() => {
                            setState({
                                ...offersFilter,
                                campaignId: undefined,
                                page: 1,
                            });
                            setCampaignFilter('');
                        }}
                    />
                </div>
                <div className="col-6 col-md-3 autocomplete-input">
                    <AutocompleteInput
                        placeholder="Client name"
                        onSelect={client => {
                            setState({
                                ...offersFilter,
                                clientId: client.id,
                                page: 1,
                            });
                        }}
                        setFilter={setClientFilter}
                        value={clientFilter}
                        items={clients}
                        hasClearBtn
                        renderItems={['id', 'displayName']}
                        clearFunc={() => {
                            setState({
                                ...offersFilter,
                                clientId: undefined,
                                page: 1,
                            });
                            setClientFilter('');
                        }}
                    />
                </div>
                <div className="col-6 col-md-3 autocomplete-input">
                    <AutocompleteInput
                        placeholder="Manager name"
                        onSelect={manager => {
                            setState({
                                ...offersFilter,
                                managerId: manager.id,
                                page: 1,
                            });
                        }}
                        setFilter={setManagerFilter}
                        value={managerFilter}
                        items={managers}
                        hasClearBtn
                        renderItems={['id', 'firstName', 'lastName']}
                        clearFunc={() => {
                            setState({
                                ...offersFilter,
                                managerId: undefined,
                                page: 1,
                            });
                            setManagerFilter('');
                        }}
                    />
                </div>
                <div className="col-6 col-md-3">
                    <SingleSelectDropdown
                        placeholder="Year"
                        options={years.map(year => ({ value: String(year), label: String(year) }))}
                        selected={String(offersFilter?.year || currentYear)}
                        clearable={Number(offersFilter?.year || currentYear) !== currentYear}
                        active={Number(offersFilter?.year || currentYear) !== currentYear}
                        onChange={value => handleChanges({ target: { name: 'year', value } } as any)}
                    />
                </div>
            </Row>
            <Button className="mt-4" type="button" onClick={() => handleState(offersFilter)}>
                Search
            </Button>
        </Form>
    );
}
